module.exports = __webpack_public_path__ + "static/media/twweightbelftfeeder.c16babb4.png";